module.exports = __webpack_public_path__ + "static/media/cover-6.219afb79.webp";